export default __webpack_public_path__ + "static/media/03_A.35524b78.png";